import { createAction } from 'redux-actions';

import {
  SEND_VERIFY_CODE,
  SEND_VERIFY_CODE_ERROR,
  SEND_VERIFY_CODE_SUCCESS,
  SET_VERIFY_ITEM,
  CONFIRM_VERIFY_CODE,
  CONFIRM_VERIFY_CODE_ERROR,
  CONFIRM_VERIFY_CODE_SUCCESS,
  CLEAR_CONFIRM_VERIFY_CODE_ERROR_DATA,
  CREATE_PATIENT_ACCOUNT,
  CREATE_PATIENT_ACCOUNT_ERROR,
  CREATE_PATIENT_ACCOUNT_SUCCESS,
  CREATE_PATIENT_INF,
  CREATE_PATIENT_INF_ERROR,
  CREATE_PATIENT_INF_SUCCESS,
  LOAD_LIST_PATIENT_KIN,
  LOAD_LIST_PATIENT_KIN_ERROR,
  LOAD_LIST_PATIENT_KIN_SUCCESS,
  RESET_LIST_PATIENT_KIN,

  //create case
  CREATE_CASE,
  CREATE_CASE_SUCCESS,
  CREATE_CASE_ERROR,
} from './type';

export const sendVerifyCodeAction = createAction(SEND_VERIFY_CODE);
export const sendVerifyCodeErrorAction = createAction(SEND_VERIFY_CODE_ERROR);
export const sendVerifyCodeSuccessAction = createAction(
  SEND_VERIFY_CODE_SUCCESS,
);
export const setVerifyItemAction = createAction(SET_VERIFY_ITEM);

export const confirmVerifyCodeAction = createAction(CONFIRM_VERIFY_CODE);
export const confirmVerifyCodeErrorAction = createAction(
  CONFIRM_VERIFY_CODE_ERROR,
);
export const confirmVerifyCodeSuccessAction = createAction(
  CONFIRM_VERIFY_CODE_SUCCESS,
);
export const clearConfirmVerifyCodeErrorDataAction = createAction(
  CLEAR_CONFIRM_VERIFY_CODE_ERROR_DATA,
);

export const createPatientAccountAction = createAction(CREATE_PATIENT_ACCOUNT);
export const createPatientAccountErrorAction = createAction(
  CREATE_PATIENT_ACCOUNT_ERROR,
);
export const createPatientAccountSuccessAction = createAction(
  CREATE_PATIENT_ACCOUNT_SUCCESS,
);

export const createPatientInfAction = createAction(CREATE_PATIENT_INF);
export const createPatientInfErrorAction = createAction(
  CREATE_PATIENT_INF_ERROR,
);
export const createPatientInfSuccessAction = createAction(
  CREATE_PATIENT_INF_SUCCESS,
);

export const loadListPatientKinAction = createAction(LOAD_LIST_PATIENT_KIN);
export const loadListPatientKinErrorAction = createAction(
  LOAD_LIST_PATIENT_KIN_ERROR,
);
export const loadListPatientKinSuccessAction = createAction(
  LOAD_LIST_PATIENT_KIN_SUCCESS,
);
export const resetListPatientKin = createAction(RESET_LIST_PATIENT_KIN);

// create case
export const createCaseAction = createAction(CREATE_CASE);
export const createCaseSuccessAction = createAction(CREATE_CASE_SUCCESS);
export const createCaseErrorAction = createAction(CREATE_CASE_ERROR);
